import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sales-order-cancel-dialog',
  templateUrl: './sales-order-cancel-dialog.component.html',
  styleUrls: ['./sales-order-cancel-dialog.component.scss']
})
export class SalesOrderCancelDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SalesOrderCancelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  cancelOrder(cancelAllVersions: boolean) {
    this.dialogRef.close({
      cancelAllVersions: cancelAllVersions
    });
  }

}
